import { CustomEventName } from '@/constants';
import { useStatsigClient } from '@statsig/react-bindings';
import { resetDataLayerAndPushEvent } from '..';
import {
  type ConnectEmailSuccessArgs,
  type SignUpSuccessArgs,
  buildConnectEmailSuccessParams,
  buildSignUpSuccessParams,
  normaliseForStatsig,
} from './gtmSignEventBuilders';

// Builders, GTM push and Statsig log all run guarded: tracking must never break login/connect flows.
// GTM push goes first in its own try/catch so a Statsig failure never skips it.
export const useTrackSignEvents = () => {
  const { logEvent } = useStatsigClient();

  const emit = (name: string, buildParams: () => Record<string, unknown>) => {
    let params: Record<string, unknown>;
    try {
      params = buildParams();
    } catch (error) {
      console.error(`useTrackSignEvents ${name} build`, error);
      return;
    }
    try {
      resetDataLayerAndPushEvent(name, params);
    } catch (error) {
      console.error(`useTrackSignEvents ${name} gtm`, error);
    }
    try {
      logEvent(name, undefined, normaliseForStatsig(params));
    } catch (error) {
      console.error(`useTrackSignEvents ${name} statsig`, error);
    }
  };

  return {
    signUpSuccess: (args: SignUpSuccessArgs) =>
      emit(CustomEventName.SignUpSuccess, () => buildSignUpSuccessParams(args)),
    connectEmailSuccess: (args: ConnectEmailSuccessArgs) =>
      emit(CustomEventName.ConnectEmailSuccess, () => buildConnectEmailSuccessParams(args)),
  };
};
